import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const SidebarIcon = React.memo(function SidebarIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="2.5"
        width="12"
        height="10"
        rx="1"
        stroke={color}
      />
      <line x1="5.5" y1="2.5" x2="5.5" y2="12.5" stroke={color} />
    </svg>
  );
});
